export const canDeletePartner = (partner, user) => {
    if (partner.isDefault) {
        if (user.type !== 'admin') return false
    }
    return true
}
